﻿$.fn.dxCtrlPwd = function custom_dxCtrlPwd(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlpwd dx-ctrl");
        this.createInstance(new cdxCtrlPwd(this, option));
    }
    return this;
}

//DevExpress.ui.dxTextBox.defaultOptions({
//    device: { deviceType: "desktop" },
//    options: {
//        onContentReady: function (info) {
//            $(info.element).find("input").attr("autocomplete", "new");
//        },
//    }
//});

window.cdxCtrlPwd = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.minLength == 'undefined') option.minLength = 8

    var $DivErreur = null;
    function mConstruit() {
        container.empty();


        var $Table = $("<table style='width:100%'/>").appendTo(container)
        var $Tr = $("<tr/>").appendTo($Table);
        var $Td = $("<td style=''/>").appendTo($Tr);
        dtxTextBoxPwd1 = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Saisissez le mot de passe",
            value: option.value,
            showClearButton: false,
            //disabled: true,
            inputAttr: option.inputAttr,
            placeholder: ((option.placeholder) ? option.placeholder : "Saisir " + ((typeof option.nomPwd == 'undefined') ? "le mot de passe" : option.nomPwd) + "..."),
            maxLength: option.maxLength,
            buttons: [{
                focusStateEnabled: false,
                name: 'showpwd',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    hint: "Révéler/cacher le texte",
                    focusStateEnabled: false,
                    stylingMode: 'text',
                    onClick() {
                        if (dtxTextBoxPwd1.element().find("input").hasClass("txtPassword")) {
                            dtxTextBoxPwd1.element().find("input").removeClass("txtPassword")
                            dtxTextBoxPwd2.element().find("input").removeClass("txtPassword")
                        } else {
                            dtxTextBoxPwd1.element().find("input").addClass("txtPassword")
                            dtxTextBoxPwd2.element().find("input").addClass("txtPassword")
                        }
                    },
                },
            }],
            onKeyDown: function (e) {
                dtxTextBoxPwd2.option("value", "");
                option.value = ""
                if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value);
                if (option.value.length > 0) {
                    var Txt = "Vous devez confirmer " + ((typeof option.nomPwd == 'undefined') ? "le mot de passe" : option.nomPwd) + "." + ((option.value.length < option.minLength) ? "<br/>Vous devez saisir au moins " + option.minLength + " caractères." : "")
                    $DivErreur.html(Txt);
                    $DivErreur.show()
                }
                else { $DivErreur.hide() }
            },
            onValueChanged: function (e) {
                mShowHideErreur()
                //if (e.value.length > 0) {
                //    var Txt = "Vous devez confirmer " + ((typeof option.nomPwd == 'undefined') ? "le mot de passe" : option.nomPwd) + "." + ((e.value.length < option.minLength) ? "<br/>Vous devez saisir au moins " + option.minLength + " caractères." : "")
                //    $DivErreur.html(Txt);
                //    $DivErreur.show()
                //}
                //else { $DivErreur.hide() }
            },
            onFocusIn: function (e) {
                //window.setTimeout(function () { e.component.element().find("input").attr("readonly", false) }, 0);
            },
            onFocusOut: function (e) {
                //e.component.element().find("input").attr("readonly", true)
            },
            onContentReady: function (e) {
                ////$(e.element).find("input").attr("autocomplete", "new-password");
                //window.setTimeout(function () { e.component.option("disabled", false) }, 500);
                ////e.component.element().find("input").parent().prepend($('<input id="password" style="display:none" type="password" name="fakepasswordremembered"/>'))
                //e.component.element().find("input").attr("readonly", true)
                e.component.element().find("input").addClass("txtPassword")
            }
        }).dxCtrlTextBox("instance")
        if (typeof option.layout == 'undefined' || option.layout == 'vertical') $Tr = $("<tr/>").appendTo($Table);
        var $Td = $("<td style='' class='td2pwd'/>").appendTo($Tr);
        dtxTextBoxPwd2 = $("<div/>").appendTo($Td).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Confirmez le mot de passe",
            value: option.value,
            showClearButton: false,
            inputAttr: option.inputAttr,
            //disabled: true,
            placeholder: ((option.placeholder) ? option.placeholder : "Confirmer " + ((typeof option.nomPwd == 'undefined') ? "le mot de passe" : option.nomPwd) + "..."),
            maxLength: option.maxLength,
            buttons: [{
                focusStateEnabled: false,
                name: 'showpwd',
                location: 'after',
                options: {
                    icon: 'eyeopen',
                    hint: "Révéler/cacher le texte",
                    focusStateEnabled: false,
                    stylingMode: 'text',
                    onClick() {
                        if (dtxTextBoxPwd1.element().find("input").hasClass("txtPassword")) {
                            dtxTextBoxPwd1.element().find("input").removeClass("txtPassword")
                            dtxTextBoxPwd2.element().find("input").removeClass("txtPassword")
                        } else {
                            dtxTextBoxPwd1.element().find("input").addClass("txtPassword")
                            dtxTextBoxPwd2.element().find("input").addClass("txtPassword")
                        }
                    },
                },
            }],
            onKeyDown: function (e) { $DivErreur.hide() },
            onValueChanged: function (e) {
                mShowHideErreur()
                //var txt = ""
                //if (dtxTextBoxPwd1.option("value") != e.value) txt = "Les saisies ne correspondent pas."
                //if (dtxTextBoxPwd1.option("value").length < option.minLength) {
                //    if (txt.length > 0) txt += "<br/>"
                //    txt += "Vous devez saisir au moins " + option.minLength + " caractères."
                //}
                //if (txt.length==0) {
                //    option.value = e.value;
                //    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value);
                //    $DivErreur.hide()
                //}
                //else {
                //    $DivErreur.html(txt);
                //    $DivErreur.show()
                //}
            },
            onFocusIn: function (e) {
                //window.setTimeout(function () { e.component.element().find("input").attr("readonly", false) }, 0);
            },
            onFocusOut: function (e) {
                //e.component.element().find("input").attr("readonly", true)
            },
            onContentReady: function (e) {
                //window.setTimeout(function () { e.component.option("disabled", false) }, 500);
                ////e.component.element().find("input").parent().prepend($('<input id="password" style="display:none" type="password" name="fakepasswordremembered"/>'))
                //e.component.element().find("input").attr("readonly", true)
                e.component.element().find("input").addClass("txtPassword")
            }
        }).dxCtrlTextBox("instance")

        if (typeof option.onlyNumber != 'undefined' && option.onlyNumber) {
            dtxTextBoxPwd1.option("onKeyDown", function (e) {
                var event = e.event;
                var str = String.fromCharCode(event.keyCode);
                if (!/[0-9]/.test(str)) {
                    event.preventDefault();
                }
            });
            dtxTextBoxPwd2.option("onKeyDown", function (e) {
                var event = e.event;
                var str = String.fromCharCode(event.keyCode);
                if (!/[0-9]/.test(str)) {
                    event.preventDefault();
                }
            });
        }

        var $DivErreurMaitre = $("<div style='height:28px'/>").appendTo(container)
        $DivErreur = $("<div style='color:red;display:none;text-align:left;font-style:italic;font-size:80%;'>").appendTo($DivErreurMaitre);
        //if (!option.value || option.value.length == 0) {
        //    $DivErreur.text("Vous devez saisir " + ((typeof option.nomPwd == 'undefined') ? "le mot de passe" : option.nomPwd) + ""); $DivErreur.show()
        //}
    }

    function mShowHideErreur() {
        var txt = Me.mGetTextErreur()
        //if (dtxTextBoxPwd1.option("value") != dtxTextBoxPwd2.option("value")) txt = "Les saisies ne correspondent pas."
        //if (dtxTextBoxPwd1.option("value") == null || dtxTextBoxPwd1.option("value").length < option.minLength) {
        //    if (txt.length > 0) txt += "<br/>"
        //    txt += "Vous devez saisir au moins " + option.minLength + " caractères."
        //}
        if (txt.length == 0) {
            option.value = dtxTextBoxPwd1.option("value");
            if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value);
            $DivErreur.hide()
        }
        else {
            $DivErreur.html(txt);
            $DivErreur.show()
        }
    }
    this.mGetTextErreur = function () {
        var txt = ""
        if (dtxTextBoxPwd1.option("value") != dtxTextBoxPwd2.option("value")) txt = "Les saisies ne correspondent pas."
        if (dtxTextBoxPwd1.option("value") == null || dtxTextBoxPwd1.option("value").length < option.minLength) {
            if (txt.length > 0) txt += "<br/>"
            txt += "Vous devez saisir au moins " + option.minLength + " caractères."
        }
        return txt
        //if (txt.length == 0) {
        //    option.value = dtxTextBoxPwd1.option("value");
        //    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.value);
        //    $DivErreur.hide()
        //}
        //else {
        //    $DivErreur.html(txt);
        //    $DivErreur.show()
        //}
    }

    this.element = function () { return container; }

    this.focus = function () { dtxTextBoxPwd1.component().focus(); }

    this.isOk = function () { return option.value && option.value.length > 0 }

    this.disabled = function (value) {
        dtxTextBoxPwd1.option("disabled",value)
        dtxTextBoxPwd2.option("disabled",value)
    }

    mConstruit();
}